import React from 'react';
import PropTypes from 'prop-types';
import SidebarHeader from '@99designs/ddo/components/SidebarHeader';
import MainCtaButton from 'apps/designdetails/components/MainCtaButton';
import SecondaryButtonContainer from 'apps/designdetails/components/SecondaryButtonContainer';
import DesignAttribution from './DesignAttribution';

export default class DesignActions extends React.Component {
    designTitle() {
        return (
            <SidebarHeader.Heading>
                <SidebarHeader.HeadingText>
                    <div> { this.props.design.name } </div>
                </SidebarHeader.HeadingText>
            </SidebarHeader.Heading>
        );
    }

    render() {
        return (
            <div>
                <SidebarHeader.Section>
                    { this.designTitle() }
                    <DesignAttribution
                        design={this.props.design}
                        activeUser={this.props.activeUser}
                    />
                    <div className="section">
                        <MainCtaButton design={this.props.design} />
                    </div>
                    <SecondaryButtonContainer design={this.props.design} />
                </SidebarHeader.Section>
            </div>
        );
    }
}

DesignActions.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    activeUser: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/components/DesignActions.jsx